import VueHeadful from 'vue-headful'
import FontAwesomeIcon from '@/components/FontAwesomeIcon'

const GlobalComponents = {
  install(Vue) {
    Vue.component('vue-headful', VueHeadful)
    Vue.component('fa-icon', FontAwesomeIcon)
  },
}

export default GlobalComponents
